<template>
  <div class="flex items-center gap-1 text-sm">
    <router-link
      :to="switchLocalePath('ro')"
      :class="[
        'transition-opacity',
        locale === 'ro' ? 'font-bold' : 'opacity-70 hover:opacity-100',
      ]"
      @click="syncLocale('ro')"
    >
      RO
    </router-link>
    <span class="opacity-40">/</span>
    <router-link
      :to="switchLocalePath('en')"
      :class="[
        'transition-opacity',
        locale === 'en' ? 'font-bold' : 'opacity-70 hover:opacity-100',
      ]"
      @click="syncLocale('en')"
    >
      EN
    </router-link>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useLocalePath } from '../composables/useLocalePath'
import { useAuthStore } from '../stores/auth'
import usersApi from '../api/users'

const { locale } = useI18n()
const { switchLocalePath } = useLocalePath()
const authStore = useAuthStore()

const syncLocale = async (targetLocale) => {
  if (authStore.isAuthenticated && authStore.user?.preferred_locale !== targetLocale) {
    try {
      const response = await usersApi.updateProfile({ preferred_locale: targetLocale })
      authStore.user = response.data
    } catch {
      // Silently fail - navigation still works, locale just won't persist server-side
    }
  }
}
</script>
